module.exports = __webpack_public_path__ + "img/menu-gd.40d236ec.png";